import {
    FAILED,
    INITIAL,
    LOADING,
    SUCCESS,
    UNAUTHORIZED,
} from 'business/constants';

import { ChartStatus } from 'components/StatusManager';
import { HttpError } from 'store/APIClient';

export const getChartStatus = (
    hasMetrics: boolean,
    chartHasError: boolean,
    isLoading: boolean,
    error: HttpError | null,
): ChartStatus => {
    if (chartHasError) return FAILED;
    if (isLoading) return LOADING;
    if (!isLoading && !error) return SUCCESS;
    if (!isLoading && error && error.status === 401) return UNAUTHORIZED;
    if (!isLoading && error) return FAILED;
    return hasMetrics ? LOADING : INITIAL;
};
